import { NotificationType } from 'models/notifications'
import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { OutlinedButton } from 'ui/buttons/OutlinedButton'

interface IButtonBlock {
	type: NotificationType
	object_id: number
	setOpenNotifications: (bool: boolean) => void
}

export const ButtonBlock = ({
	type,
	object_id,
	setOpenNotifications,
}: IButtonBlock) => {
	const dictionary = useMemo(() => {
		return {
			[NotificationType.RATION_GROUP_LINK]: `/feed/ration/${object_id}`,
			[NotificationType.RATION_CHANGE]: `/feed/ration/${object_id}`,
			[NotificationType.HEALTH_TODAY_PLAN]: '/cattles/lameness',
			[NotificationType.HEALTH_FATNESS_STATISTICS]: '/cattles/fatness',
			[NotificationType.MILKING_PROCESS_DEVIATIONS]: '/milking-process',
		}
	}, [object_id])
	const navigate = useNavigate()

	const redirectToPath = useCallback(() => {
		const path = dictionary[type]
		navigate(path)
		setOpenNotifications(false)
	}, [dictionary, navigate, setOpenNotifications, type])
	if (!dictionary[type]) {
		return null
	}

	return (
		<OutlinedButton sx={{ width: '100%' }} onClick={redirectToPath}>
			Подробнее
		</OutlinedButton>
	)
}
